import { useLayoutEffect, useState } from "react";

/** Matches `PreviewHeader` / `EditorHeader` (`h-16`). */
export const CONTENT_HUB_CANVAS_HEADER_HEIGHT_PX = 64;

const CANVAS_EDIT_PATH = /\/org\/[^/]+\/page\/[^/]+\/edit\/?$/;

function isCanvasEditRoute(pathname: string): boolean {
  return CANVAS_EDIT_PATH.test(pathname.split("?")[0]);
}

/**
 * On canvas `/edit` preview, reserve space under the hub chrome only while the
 * page canvas is scrolled to the top (preview bar visible). When the user has
 * scrolled the page, use a full-viewport player overlay.
 */
export function useCanvasPreviewHeaderOffsetPx(): number {
  const [offsetPx, setOffsetPx] = useState(0);

  useLayoutEffect(() => {
    if (
      typeof window === "undefined" ||
      !isCanvasEditRoute(window.location.pathname)
    ) {
      setOffsetPx(0);
      return;
    }

    const scrollEl = document.querySelector<HTMLElement>(
      "[data-content-hub-editor-scroll]"
    );
    if (!scrollEl) {
      setOffsetPx(0);
      return;
    }

    const update = () => {
      setOffsetPx(
        scrollEl.scrollTop < CONTENT_HUB_CANVAS_HEADER_HEIGHT_PX
          ? CONTENT_HUB_CANVAS_HEADER_HEIGHT_PX
          : 0
      );
    };

    update();
    scrollEl.addEventListener("scroll", update, { passive: true });
    return () => scrollEl.removeEventListener("scroll", update);
  }, []);

  return offsetPx;
}
